/**
 * downloadBase64 — spustí lokální stažení souboru z MCP tool odpovědi
 * `{ ok, filename, content_type, base64 }`. Žádné síťové volání — jen
 * dekódování base64 → Blob → objectURL → click na <a download>.
 */
export function downloadBase64(base64: string, filename: string, contentType?: string): void {
  const bin = atob(base64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  const blob = new Blob([bytes], contentType ? { type: contentType } : undefined);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
